import './resultado-geral.scss';

const { estado, turno } = window;
// const numRowsTableOutrosResultados = 5;
const numRowsTableOutrosResultados = 3;

// const urlJson = `https://infograficos-eleicoes-2018.s3.amazonaws.com/oglobo_digital/${estado}/resultado-geral-governador.json`;
const urlPrefix = 'https://infograficos-estaticos.s3.amazonaws.com/eleicao-2018-mapas/governador/rj';
const imgPathPrefix = `${urlPrefix}/img/candidatos/governador/${estado}`;

const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

let tituloSectionResultado = 'O resultado no estado';
tituloSectionResultado = (estado.toLowerCase() === 'rj') ? 'O resultado no Rio de Janeiro no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = (estado.toLowerCase() === 'sp') ? 'O resultado em São Paulo no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = (estado.toLowerCase() === 'mg') ? 'O resultado em Minas Gerais no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = (estado.toLowerCase() === 'rs') ? 'O resultado no Rio Grande do Sul no primeiro turno' : tituloSectionResultado;
$('.resultado-geral__titulo').innerHTML = tituloSectionResultado;

//#region FUNCTIONS
// Adiciona ponto a cada 3 digitos em um float e retorna em double
const intWithDots = (n) => {
  n = parseInt(n, 10).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari ?
    n.substring(2, n.length - 2) :
    n.substring(3, n.length - 3);
};

// Animacao de contador para um numero inteiro ou float
const animPercent = (el, initialNum, finalNum) => {
  if (finalNum) {
    if (Number.isInteger(finalNum)) {
      const interval = setInterval(function() {
        el.innerHTML = `${initialNum}%`;
        (initialNum >= finalNum) ? clearInterval(interval) : '';
        initialNum++;
      }, 50);
    } else {
      let intInitialNum = Math.floor(initialNum);
      const intFinalNum = Math.floor(finalNum);
      const interval = setInterval(function() {
        el.innerHTML = `${intInitialNum}%`;
        if (intInitialNum >= intFinalNum) {
          clearInterval(interval);
          el.innerHTML = `${finalNum.toString().replace('.', ',')}%`;
        }
        intInitialNum++;
      }, 50);
    }
  }
};
//#endregion FUNCTIONS


// Altera a navbar e o titulo da section de resultado para o estado atual
$$('.gov-nav__square').forEach((el) => {
  if (el.innerHTML.toLowerCase() === estado.toLowerCase()) {
    el.classList.add('gov-nav__square--active');
    el.href = 'javascript:void(0)';
  }
});

// Altera o turno selcionado na nav caso seja o turno 2
if (turno === 2) {
  $('.turnos-nav__squares-container').innerHTML = `
    <a class="turnos-nav__square" href="https://infograficos.oglobo.globo.com/brasil/mapa-eleicao-2018-governador-${estado}.html">1º turno</a>
    <a class="turnos-nav__square turnos-nav__square--active" href="javascript:void(0)">2º turno</a>
  `;
}


const populateHeader = (data) => {
  const Resultado = data;
  // console.log('Resultado', Resultado);
  const cands = [];

  (Resultado.total.candidatos).forEach((cand) => {
    // Somente candidatos validos
    if (
      cand.total_votos_validos != '0' &&
      Resultado.candidatos[cand.id_candidato].nome_candidato
    ) {
      cands.push({
        num: cand.id_candidato,
        perc: parseFloat(cand.total_percentual.replace(',', '.')),
        vot: parseInt((cand.total_votos_validos).split('.').join(''), 10),
        eleito: Resultado.candidatos[cand.id_candidato].eleito === 'S',
        nome: Resultado.candidatos[cand.id_candidato].nome_candidato.toLowerCase(),
        part: Resultado.candidatos[cand.id_candidato].sigla_partido,
      });
    }
  });
  // console.log('cands', cands);

  const votosTotais = parseInt((Resultado.total.total).split('.').join(''), 10);
  const votosBrancos = parseInt((Resultado.total.brancos).split('.').join(''), 10);
  const votosNulos = parseInt((Resultado.total.nulos).split('.').join(''), 10);
  const votosValidos = votosTotais - votosBrancos - votosNulos;
  const percentBrancos = Math.round(((votosBrancos * 100) / votosTotais) * 100) / 100;
  const percentNulos = Math.round(((votosNulos * 100) / votosTotais) * 100) / 100;

  const sortedCandidatos = cands.sort((a, b) => (a.vot < b.vot ? 1 : -1));
  // const sortedCandidatos = cands;

  const $TableOutrosResultados = $('.resultado-geral__outros-resultados');
  const $Top3Candidatos = $$('.candidato-top-3');
  const $Top3Percents = $$('.candidato-top-3__percentual');
  const $LabelEleito = $('.candidato-top-3__legenda-eleito');
  const $LabelsSegundoTurno = $$('.candidato-top-3__legenda-segundo-turno');
  const $ValorTotalUrnas = $('.resultado-urnas-apuradas span');
  const $ValorTotalVotosApurados = $('.resultado-total-votos-apurados span');

  let htmlTableOutrosResultados = '';
  const isTopOfTableOutrosResultados = (n) => {
    return (((n + 1) - 3) + (numRowsTableOutrosResultados - 1)) % numRowsTableOutrosResultados;
  };
  const isBottomOfTableOutrosResultados = (n) => {
    return ((n + 1) - 3) % numRowsTableOutrosResultados;
  };


  // Labels "Eleito" e "Segundo turno"
  if (turno === 1) {
    $LabelsSegundoTurno[0].style.display = 'flex';
    $LabelsSegundoTurno[1].style.display = 'flex';
  } else if (turno === 2) {
    $LabelEleito.style.display = 'flex';
  }

  // Candidatos
  sortedCandidatos.forEach((cand, i) => {
    const qtdCandHeader = (turno === 2) ? 2 : 3;

    if (turno === 2) {
      // $Top3Candidatos[2].style.display = 'none';
      // $('.resultado-geral__top-3').style.maxWidth = '720px';
    }
    // Top 3
    if (i < qtdCandHeader) {
      const candImg = `${imgPathPrefix}/${cand.num}.png`;
      const silhouetteImg = `${urlPrefix}/img/candidatos/silhueta.png`;

      $Top3Candidatos[i].querySelector('.candidato-top-3__img > img').src = candImg;

      const img = new Image();
      img.onerror = () => { $Top3Candidatos[i].querySelector('.candidato-top-3__img > img').src = silhouetteImg; };
      img.src = candImg;

      $Top3Candidatos[i].querySelector('.candidato-top-3__nome').innerHTML = cand.nome.toLowerCase();
      $Top3Candidatos[i].querySelector('.candidato-top-3__partido').innerHTML = cand.part;
      animPercent($Top3Percents[i], 0, cand.perc);
      $Top3Candidatos[i].querySelector('.candidato-top-3__votos').innerHTML = `${intWithDots(cand.vot)} votos`;
    }
    // Tabela do 4 em diante
    else if (turno === 1) {
      isTopOfTableOutrosResultados(i) === 0
        ? htmlTableOutrosResultados += '<div class="outros-resultados__column">'
        : '';

      htmlTableOutrosResultados += `
        <div class="outros-resultados__row">
          <div class="outros-resultados__nome">${cand.nome} (${cand.part})</div>
          <div class="outros-resultados__percentual">${cand.perc.toString().replace('.', ',')}%</div>
          <div class="outros-resultados__votos">${intWithDots(cand.vot)}</div>
        </div>
      `;

      isBottomOfTableOutrosResultados(i) === 0 || i == (sortedCandidatos.length - 1)
        ? htmlTableOutrosResultados += '</div>'
        : '';
      }
  });
  // Adiciona os brancos, nulos e abstencoes
  htmlTableOutrosResultados += `
    <div class="outros-resultados__column">
      <div class="outros-resultados__row">
        <div class="outros-resultados__nome">Brancos</div>
        <div class="outros-resultados__percentual">${(isNaN(percentBrancos) ? 0 : percentBrancos).toString().replace('.', ',')}%</div>
        <div class="outros-resultados__votos">${intWithDots(votosBrancos)}</div>
      </div>
      <div class="outros-resultados__row">
        <div class="outros-resultados__nome">Nulos</div>
        <div class="outros-resultados__percentual">${(isNaN(percentNulos) ? 0 : percentNulos).toString().replace('.', ',')}%</div>
        <div class="outros-resultados__votos">${intWithDots(votosNulos)}</div>
      </div>
      <!--
      <div class="outros-resultados__row">
        <div class="outros-resultados__nome">Abstenções</div>
        <div class="outros-resultados__percentual">0%</div>
        <div class="outros-resultados__votos">0</div>
      </div>
      -->
    </div>
  `;
  // Append no HTML
  $TableOutrosResultados.innerHTML = htmlTableOutrosResultados;

  // Totais de urnas e votos
  // $ValorTotalUrnas.innerHTML = `${Resultado.urnaA.toString().replace(/\./g, ',')}%`;
  // $ValorTotalVotosApurados.innerHTML = intWithDots(Resultado.totalApu);
  $ValorTotalUrnas.innerHTML = Resultado.atualizacao.apuracao_total;
  $ValorTotalVotosApurados.innerHTML = Resultado.total.total;
};

export default populateHeader;



// WEBPACK FOOTER //
// ./src/partials/resultado-geral.js